export default "Privatbesuch";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/visit/answer.js